export const CONTENTFUL_NEWS_PAGE_SIZE = 100;

function makeNewsItemKey(item, index) {
  if (!item || typeof item !== 'object') {
    return `unknown:${index}`;
  }

  if (item.route) {
    return `route:${item.route}`;
  }

  return [
    item.newsTitle || '',
    item.date || '',
    item.videoLink || '',
    index,
  ].join('|');
}

function dedupeNewsItems(items) {
  const seen = new Set();

  return (items || []).filter((item, index) => {
    const key = makeNewsItemKey(item, index);

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
}

export function shouldPaginateNewsItems(queryData, metaFieldName = '_newsItemsMeta') {
  if (!queryData || queryData.loading || queryData.error || typeof queryData.fetchMore !== 'function') {
    return false;
  }

  const currentItems = Array.isArray(queryData.newsItems) ? queryData.newsItems : [];
  const totalCount = queryData[metaFieldName] && typeof queryData[metaFieldName].count === 'number'
    ? queryData[metaFieldName].count
    : null;

  return totalCount !== null && currentItems.length < totalCount;
}

export async function fetchAllNewsItemsPages(queryData, options = {}) {
  const {
    metaFieldName = '_newsItemsMeta',
    pageSize = CONTENTFUL_NEWS_PAGE_SIZE,
  } = options;

  if (!shouldPaginateNewsItems(queryData, metaFieldName)) {
    return Array.isArray(queryData && queryData.newsItems) ? queryData.newsItems : [];
  }

  let mergedItems = dedupeNewsItems(queryData.newsItems);
  let totalCount = queryData[metaFieldName].count;

  while (mergedItems.length < totalCount) {
    const nextResult = await queryData.fetchMore({
      variables: {
        newsSkip: mergedItems.length,
        newsLimit: pageSize,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }

        const previousItems = Array.isArray(previousResult.newsItems) ? previousResult.newsItems : [];
        const nextItems = Array.isArray(fetchMoreResult.newsItems) ? fetchMoreResult.newsItems : [];
        const combinedNewsItems = dedupeNewsItems(previousItems.concat(nextItems));

        return {
          ...fetchMoreResult,
          newsItems: combinedNewsItems,
          [metaFieldName]: fetchMoreResult[metaFieldName] || previousResult[metaFieldName],
        };
      },
    });

    const nextItems = Array.isArray(nextResult && nextResult.newsItems) ? nextResult.newsItems : [];
    const nextCount = nextResult && nextResult[metaFieldName] && typeof nextResult[metaFieldName].count === 'number'
      ? nextResult[metaFieldName].count
      : totalCount;

    if (nextItems.length <= mergedItems.length) {
      break;
    }

    mergedItems = dedupeNewsItems(nextItems);
    totalCount = nextCount;
  }

  return mergedItems;
}
